module.exports = __webpack_public_path__ + "static/media/tv.ec5c179a.svg";